import React from 'react';
import { Box, Grid } from '@mui/material';
import SearchFilter from '../../../components/filters/SearchFilter';

const SupplierListFilters = ({
  filters,
  selectedFilter,
  onFilterChange,
  searchTerm,
  onSearchChange,
  onSearchKeyPress,
  searchPlaceholder,
}) => {
  const searchFilters = filters.filter((filter) => filter.type === 'search');

  return (
    <Grid item xs={12} container justifyContent="space-between" alignItems="center" spacing={1}>
      <Grid container spacing={1}></Grid>
      <Grid item>
        <Box display="flex" gap={1} justifyContent="flex-end">
          {searchFilters.map((filter) => (
            <SearchFilter
              key={filter.type}
              filter={filter}
              selectedFilter={selectedFilter}
              onFilterChange={onFilterChange}
              searchTerm={searchTerm}
              onSearchChange={onSearchChange}
              onSearchKeyPress={onSearchKeyPress}
              placeholder={searchPlaceholder}
            />
          ))}
        </Box>
      </Grid>
    </Grid>
  );
};

export default SupplierListFilters;
